// google requires loading=async on the bootstrap url, otherwise the api logs a performance warning to the console.
// when loading asynchronously the callback param is what tells us the api (and the libraries we asked for) is ready,
// so we hang a one-shot global off window for the api to call back into.
const CALLBACK_NAME = "__glGoogleMapsLoaded";

// the bootstrap is a one time thing, so hold on to the promise and let every caller share the same script tag
let loader:Promise<void> | null = null;

const buildScriptUrl = (key:string, channel:string):string => {
    const params = [
        "key=" + encodeURIComponent(key),
        "channel=" + encodeURIComponent(channel),
        "libraries=places",
        "loading=async",
        "callback=" + CALLBACK_NAME
    ];
    return "https://maps.googleapis.com/maps/api/js?" + params.join("&");
};

export const loadGoogleMaps = (key:string, channel:string):Promise<void> => {

    if(loader){
        return loader;  // already loaded, or still in flight - either way the caller waits on the original request
    }

    loader = new Promise<void>((resolve, reject) => {

        if(window.google && window.google.maps){
            resolve();  // the api is already on the page, nothing to bootstrap
            return;
        }

        const cleanup = () => {
            delete window[CALLBACK_NAME];
        };

        window[CALLBACK_NAME] = () => {
            cleanup();
            resolve();
        };

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = buildScriptUrl(key, channel);
        script.onerror = () => {
            cleanup();
            reject(new Error("Failed to load the Google Maps JavaScript API"));
        };
        document.body.appendChild(script);
    });

    return loader;
};

// tests only - the module level promise otherwise leaks between cases
export const resetGoogleMapsLoader = () => {
    loader = null;
    delete window[CALLBACK_NAME];
};
